<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h5 class="text-xs tracking-wide font-medium uppercase text-gray-400">Google</h5>
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              User Lists
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <!-- Actions -->
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <UserListList />
      </div>
    </div>
  </div>
</template>

<script>
import { UserListList } from './userLists/components';

export default {
  components: {
    UserListList,
  },
};
</script>
